window.ACTICLEAR_CONTENT = {
  "capturedAt": "2026-09-07T00:42:04.166446+00:00",
  "products": {
    "compact": {
      "intro": "Sinking tablets for organic buildup and sludge in ponds, koi ponds, fountains, birdbaths and backyard water gardens. Compact packages are available in 0.5lb, 1lb, 2lb and 4lb.",
      "sourceIds": [
        "compact-pdp",
        "catalog",
        "guide-thread-muck-clear",
        "owner-muck-schedule-20260907",
        "owner-muck-care-20260907"
      ],
      "guideId": "muck-clear-compact",
      "details": [
        {
          "title": "Count tablets for the water volume",
          "text": "Use 1 tablet per 25 US gallons, then spread the checked dose across the water being treated and let the tablets sink. The guide includes a dose table and a 14-day routine or 7-day heavy-buildup schedule.",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        },
        {
          "title": "Choose the package, then the pack",
          "text": "Choose 0.5lb, 1lb, 2lb or 4lb for the weight of each package, then select a 1-pack, 2-pack or 3-pack of that size. Quantity counts sets of your selected pack.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        },
        {
          "title": "What the photographs show",
          "text": "The four single-package sizes have distinct source photographs. Check the selected size and pack count together: package size describes each item; pack count describes the number of packages.",
          "sourceIds": [
            "catalog"
          ]
        }
      ],
      "faqs": [
        {
          "q": "How do the tablets reach the muck?",
          "a": "Spread the checked dose at several points from safe, stable bank positions. Let the tablets sink naturally; do not premix them in water, bury them or enter the pond to place them.",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        },
        {
          "q": "How often should I apply Compact?",
          "a": "Routine care: every 14 days. Heavy buildup: every 7 days. Check buildup and water conditions before each dose, and count from your last actual application. Best results above 50°F (10°C).",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        },
        {
          "q": "Is a 2-pack the same as a 2lb package?",
          "a": "No. A 2-pack contains two packages of the size you select. For example, a 2-pack of 0.5lb contains two 0.5lb packages; a single 2lb package is a different option.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        },
        {
          "q": "Do I need an aerator?",
          "a": "Aeration is recommended for best results. Use the same stated dose and schedule with or without a dedicated aerator. Remove reachable leaves and uneaten feed, keep part of the surface clear, and keep existing circulation or filtration running as instructed.",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        }
      ],
      "decisionFacts": [
        {
          "title": "The task",
          "text": "Sinking tablets for organic muck and sludge at the bottom of ponds and water features.",
          "sourceIds": [
            "compact-pdp"
          ]
        },
        {
          "title": "Choose a package",
          "text": "Choose 0.5lb, 1lb, 2lb or 4lb per package. Each size offers 1-pack, 2-pack and 3-pack options.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        },
        {
          "title": "Plan the routine",
          "text": "Use 1 tablet per 25 US gallons. Routine care is every 14 days; heavy buildup is every 7 days, after checking conditions.",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        }
      ],
      "detailSummary": [
        {
          "title": "For organic pond buildup",
          "text": "Sinking tablets for ponds, koi ponds, fountains, birdbaths and backyard water gardens. Count the tablets for the water volume being treated.",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        },
        {
          "title": "The format",
          "text": "Available in compact packages. Package weight and the number of packages are separate choices.",
          "sourceIds": [
            "catalog"
          ]
        },
        {
          "title": "Beneficial bacteria and enzymes",
          "text": "Beneficial bacteria and enzymes help break down organic muck and sludge.",
          "sourceIds": [
            "amazon-listing-20260920"
          ]
        },
        {
          "title": "Package counts",
          "text": "The 0.5lb package contains approximately 250 tablets; the 1lb package contains approximately 500 tablets. Choose the package weight separately from the number of packages.",
          "sourceIds": [
            "amazon-listing-20260920"
          ]
        }
      ],
      "instructionSummary": {
        "title": "Count → Spread → Let sink → Record",
        "scope": "Treat organic buildup and sludge in ponds, koi ponds, fountains, birdbaths and backyard water gardens. This guide is for the small bottle, dosed by tablet count.",
        "steps": [
          {
            "title": "Count the required tablets",
            "text": "Use 1 tablet per 25 US gallons. Find your water volume in the full guide’s dose table, count the tablets and close the bottle. Spread the dose across the water being treated; do not pile it in one corner.",
            "sourceIds": [
              "guide-thread-muck-clear",
              "owner-muck-schedule-20260907",
              "owner-muck-care-20260907"
            ]
          },
          {
            "title": "Spread, do not pile",
            "text": "Distribute the checked dose at several points from safe, stable bank positions rather than in one pile. Use the measured dose for your treatment area.",
            "sourceIds": [
              "guide-thread-muck-clear",
              "owner-muck-schedule-20260907",
              "owner-muck-care-20260907"
            ]
          },
          {
            "title": "Let the tablets sink",
            "text": "Let the tablets sink naturally. Do not premix them in water, bury them or enter the pond to place them; continue normal pond care afterward.",
            "sourceIds": [
              "guide-thread-muck-clear",
              "owner-muck-schedule-20260907",
              "owner-muck-care-20260907"
            ]
          },
          {
            "title": "Record and plan your check",
            "text": "Record the date and tablet count, and plan a check in 7 days. Before the next dose, use the full guide’s schedule to review conditions and count from your last actual application.",
            "sourceIds": [
              "guide-thread-muck-clear",
              "owner-muck-schedule-20260907",
              "owner-muck-care-20260907"
            ]
          }
        ]
      },
      "sourceConflict": {
        "topic": "repeat schedule",
        "text": "The current website FAQ gives a two-week schedule; older product instruction imagery gives four weeks. Follow the directions on the matching package you receive. If they are unclear, contact ActiClear with the product and package size before applying.",
        "sourceIds": [
          "compact-pdp",
          "compact-dose-conflict"
        ],
        "unresolved": true
      }
    },
    "large": {
      "intro": "Sinking tablets for organic muck and sludge in ponds and lakes. Choose a 5lb pail or 15lb carton. The use guide below covers the 5lb pail with premeasured 1lb bags.",
      "sourceIds": [
        "large-pdp",
        "catalog",
        "guide-thread-muck-clear-5lb",
        "owner-muck-schedule-20260907",
        "owner-muck-care-20260907"
      ],
      "guideId": "muck-clear-large",
      "details": [
        {
          "title": "5lb pail: premeasured bags",
          "text": "Each bag contains 1lb (about 454g) of tablets. Use 1 bag per 6,000 sq ft or 5 bags per 30,000 sq ft. Open the bags and spread the tablets; keep the empty packaging out of the water. No weighing is needed.",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        },
        {
          "title": "5lb and 15lb are different packages",
          "text": "The 5lb format comes in a pail; the 15lb format is shown in a carton. Check the net weight and selected package image before adding it to your bag.",
          "sourceIds": [
            "large-packaging",
            "catalog"
          ]
        },
        {
          "title": "Package count is separate from size",
          "text": "Both 5lb and 15lb sizes offer 1-pack, 2-pack and 3-pack options. Every package in a pack is the selected size. A single 15lb carton and a 3-pack of 5lb pails are separate offers; check the displayed price for each.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        }
      ],
      "faqs": [
        {
          "q": "Where is the 5lb pail intended to be used?",
          "a": "For organic buildup and sludge in ponds, koi ponds, lakes and along pond shorelines. For small fountains or birdbaths, use the Compact product and its volume-based guide.",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        },
        {
          "q": "How often should I apply the 5lb pail?",
          "a": "Routine care: every 14 days. Heavy buildup: every 7 days. Check conditions and count from the last actual application before deciding another dose is due. Best results above 50°F (10°C). The guide is specific to the 5lb pail; contact us for matching 15lb directions.",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        },
        {
          "q": "Why does the 15lb image look different?",
          "a": "The supplied 15lb product front is a carton. The 5lb product is shown as a pail; the two packages should not be visually relabeled as each other.",
          "sourceIds": [
            "large-packaging"
          ]
        },
        {
          "q": "Is a 15lb single pack priced like three 5lb packages?",
          "a": "No. A single 15lb carton and a 3-pack of 5lb pails are separate offers. Select the package size and pack count to see the current price.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        }
      ],
      "decisionFacts": [
        {
          "title": "The task",
          "text": "Sinking tablets for organic muck and sludge at the bottom of ponds and water features.",
          "sourceIds": [
            "large-pdp"
          ]
        },
        {
          "title": "Choose a package",
          "text": "Choose 5lb or 15lb per package. Each size offers 1-pack, 2-pack and 3-pack options.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        },
        {
          "title": "Plan 5lb pail care",
          "text": "Use 1 bag per 6,000 sq ft. Routine care is every 14 days; heavy buildup is every 7 days. Review conditions before applying. The 5lb guide does not set a 15lb dose.",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ]
        }
      ],
      "detailSummary": [
        {
          "title": "Pond care in a tablet format",
          "text": "Tablets sink toward settled organic debris, including muck and sludge.",
          "sourceIds": [
            "large-pdp"
          ]
        },
        {
          "title": "The format",
          "text": "Available in a 5lb pail or a 15lb carton. Package weight and the number of packages are separate choices.",
          "sourceIds": [
            "catalog",
            "large-packaging"
          ]
        },
        {
          "title": "Beneficial bacteria and enzymes",
          "text": "Beneficial bacteria and enzymes help break down organic muck and sludge.",
          "sourceIds": [
            "amazon-listing-20260920"
          ]
        }
      ],
      "instructionSummary": {
        "title": "Take bags → Open and spread → Let sink → Record",
        "scope": "For the 5lb pail with premeasured 1lb bags. Use 1 bag per 6,000 sq ft; no weighing is needed. Contact ActiClear for matching 15lb directions.",
        "steps": [
          {
            "title": "Take the required bags",
            "text": "Use 1 bag for 6,000 sq ft; each bag is 1 lb (about 454 g). Confirm the bag count for your area before applying. No weighing is needed. Keep unused bags dry in the closed pail.",
            "sourceIds": [
              "guide-thread-muck-clear-5lb",
              "owner-muck-schedule-20260907",
              "owner-muck-care-20260907"
            ]
          },
          {
            "title": "Open and spread the tablets",
            "text": "Open each bag and spread its tablets from safe, stable bank positions. Distribute them across the specified area, keep packaging out of the pond, and avoid emptying the whole dose in one spot.",
            "sourceIds": [
              "guide-thread-muck-clear-5lb",
              "owner-muck-schedule-20260907",
              "owner-muck-care-20260907"
            ]
          },
          {
            "title": "Let the tablets sink",
            "text": "Let the tablets sink naturally. Do not premix them in water, bury them or enter the pond to place them; continue normal pond care afterward.",
            "sourceIds": [
              "guide-thread-muck-clear-5lb",
              "owner-muck-schedule-20260907",
              "owner-muck-care-20260907"
            ]
          },
          {
            "title": "Record and plan your check",
            "text": "Record the date and bag count, and plan a check in 7 days. Before the next dose, use the full guide’s schedule to review conditions and count from your last actual application.",
            "sourceIds": [
              "guide-thread-muck-clear-5lb",
              "owner-muck-schedule-20260907",
              "owner-muck-care-20260907"
            ]
          }
        ]
      }
    },
    "oil": {
      "intro": "Turn used vegetable cooking oil into a removable solid: add to hot oil, stir and cool, briefly warm the bottom to loosen it, then scoop into the trash once fully cooled. Choose an 11oz or 22oz package.",
      "sourceIds": [
        "oil-pdp",
        "guide-thread-cooking-oil-solidifier",
        "owner-oil-label-exact-20260907"
      ],
      "guideId": "cooking-oil-solidifier",
      "details": [
        {
          "title": "For used vegetable cooking oil",
          "text": "For vegetable cooking oils from household food preparation. Not effective on animal fats. Do not eat the product or reuse treated oil for cooking.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        },
        {
          "title": "Measure with the product scoop",
          "text": "Use 1 scoop — 0.35oz (about 10g) — per 250mL of oil. For 500mL, use 2 scoops; for 1L, use 4 scoops. In this guide, 1 cup means 250mL.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        },
        {
          "title": "Add, stir and cool, loosen, then discard",
          "text": "With oil above the label temperature 170°F/75°C, turn off the heat before adding. Stir until all flakes melt and cool until solid. Briefly warm on low to loosen only the bottom, turn off the heat, and scoop into the trash once fully cooled.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        }
      ],
      "faqs": [
        {
          "q": "Can I add it to cold oil?",
          "a": "Add to hot used vegetable oil. Label temperature: above 170°F/75°C. Turn off the heat before adding, then stir until all flakes melt and let the oil cool at room temperature until solid.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        },
        {
          "q": "How much should I use?",
          "a": "Use 1 product scoop — 0.35oz (about 10g) — per 250mL of oil. Use 2 scoops for 500mL or 4 scoops for 1L.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        },
        {
          "q": "How do I remove the solid oil?",
          "a": "In stovetop-safe cookware, briefly warm on low to slightly melt the layer touching the pan. Turn off as soon as the base loosens; do not melt the whole block. Use a heat-resistant spatula and discard in household trash once fully cooled. Never pour it down a drain.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        },
        {
          "q": "What if the oil is fully cool but still liquid?",
          "a": "Make sure all flakes melted completely during stirring and that you used the correct amount for the oil volume. If the problem continues, contact ActiClear.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        },
        {
          "q": "Which package supports multi-packs?",
          "a": "Both 11oz and 22oz packages offer 2-pack and 3-pack options. Every package in a pack is the selected size.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        }
      ],
      "decisionFacts": [
        {
          "title": "For used cooking oil",
          "text": "Best suited to used vegetable-based oils, including canola, sunflower and soybean.",
          "sourceIds": [
            "oil-pdp"
          ]
        },
        {
          "title": "Choose your format",
          "text": "Choose 11oz or 22oz per package. Each size offers 1-pack, 2-pack and 3-pack options.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        },
        {
          "title": "Four clear steps",
          "text": "Add to hot oil with the heat off, stir and cool until solid, briefly warm the base to loosen, then remove and discard once fully cooled.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        }
      ],
      "detailSummary": [
        {
          "title": "After pan frying or deep frying",
          "text": "Flakes for turning used vegetable cooking oil into a solid mass for removal.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ]
        },
        {
          "title": "Two package sizes",
          "text": "Choose 11oz or 22oz. Measure the oil you are treating and use 1 product scoop per 250mL.",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907",
            "catalog"
          ]
        }
      ],
      "instructionSummary": {
        "title": "Add → Stir and cool → Reheat → Remove and dispose",
        "scope": "Turn used vegetable cooking oil into a solid you can scoop into the trash once fully cooled. Do not reuse treated oil for cooking.",
        "steps": [
          {
            "title": "ADD · Add to hot oil",
            "text": "While the oil is still hot — label temperature: above 170°F/75°C — turn off the heat and sprinkle in 1 scoop per 250 mL of oil.",
            "sourceIds": [
              "guide-thread-cooking-oil-solidifier",
              "owner-oil-label-exact-20260907"
            ]
          },
          {
            "title": "STIR · Stir, then cool",
            "text": "With the heat off, stir until all flakes have melted. Let the pan cool at room temperature until the oil has solidified. Fully cool but still liquid? Check the guidance below .",
            "sourceIds": [
              "guide-thread-cooking-oil-solidifier",
              "owner-oil-label-exact-20260907"
            ]
          },
          {
            "title": "REHEAT · Loosen the base",
            "text": "In stovetop-safe cookware, warm briefly over low heat to slightly melt the layer touching the pan. Turn off the heat as soon as the base loosens; do not melt the whole block. Stay with the pan.",
            "sourceIds": [
              "guide-thread-cooking-oil-solidifier",
              "owner-oil-label-exact-20260907"
            ]
          },
          {
            "title": "REMOVE & DISPOSE · Scoop into the trash",
            "text": "With the heat off, use a heat-resistant spatula to scoop out the loosened solid oil. Place it directly in household trash once fully cooled; never down a drain. Avoid touching the hot pan or oil.",
            "sourceIds": [
              "guide-thread-cooking-oil-solidifier",
              "owner-oil-label-exact-20260907"
            ]
          }
        ]
      }
    },
    "pee": {
      "intro": "Absorb collected liquid into a gel. Use Pee Powder in a separate collection bag fitted to a portable toilet for camping or travel sanitation. Choose a 2lb or 4lb package; never flush powder or gel.",
      "sourceIds": [
        "pee-pdp",
        "catalog",
        "guide-thread-pee-powder"
      ],
      "guideId": "pee-powder",
      "details": [
        {
          "title": "Fit the bag, then add the powder",
          "text": "Secure a compatible collection bag in a stable portable toilet. Measure the package dose and gently add the powder to the bottom of the bag before use. The product jug is not a waste container.",
          "sourceIds": [
            "guide-thread-pee-powder"
          ]
        },
        {
          "title": "Prepare the collection setup",
          "text": "Have a stable portable toilet, a compatible collection bag, the package-specified measuring item and the bag closure ready. Accessories shown in the guide are not necessarily included.",
          "sourceIds": [
            "guide-thread-pee-powder"
          ]
        },
        {
          "title": "Choose weight and pack count",
          "text": "Choose 2lb or 4lb per package, then select a 1-pack, 2-pack or 3-pack of that size. A single 4lb package and a 2-pack of 2lb packages are separate offers; check the displayed price for each.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        },
        {
          "title": "Check before handling",
          "text": "After use, allow the liquid to absorb, then check for unabsorbed liquid. Some visible gel or elapsed time alone does not show the bag is ready. Keep it supported if free liquid remains, and follow the guide.",
          "sourceIds": [
            "guide-thread-pee-powder"
          ]
        }
      ],
      "faqs": [
        {
          "q": "Is this the same product as oil solidifier?",
          "a": "No. Pee Powder is intended for portable liquid-waste handling. Cooking Oil Solidifier has a separate hot-oil process and separate directions.",
          "sourceIds": [
            "pee-pdp",
            "oil-pdp"
          ]
        },
        {
          "q": "When is the bag ready to handle?",
          "a": "Allow liquid to absorb into gel, then check for any unabsorbed liquid. Some visible gel or elapsed time alone is not enough. If liquid remains, keep the bag supported in the stable toilet and follow the package follow-up directions; contact us if they are missing.",
          "sourceIds": [
            "guide-thread-pee-powder"
          ]
        },
        {
          "q": "How do I add the powder?",
          "a": "Measure the package dose and gently add it to the bottom of the fitted collection bag before use. Do not assume one cap is the correct dose. If measuring directions are missing, contact ActiClear before use.",
          "sourceIds": [
            "guide-thread-pee-powder"
          ]
        },
        {
          "q": "How do I dispose of the used bag?",
          "a": "Keep the bag closed. At a campsite or managed site, use its designated sanitary-waste collection point and ask staff if unsure. At home, ask your local waste service how it accepts bagged toilet waste. Do not flush powder or gel, or empty it into water or soil.",
          "sourceIds": [
            "guide-thread-pee-powder"
          ]
        }
      ],
      "decisionFacts": [
        {
          "title": "The task",
          "text": "Powder that absorbs collected liquid into gel in a separate bag fitted to a portable toilet.",
          "sourceIds": [
            "guide-thread-pee-powder"
          ]
        },
        {
          "title": "Choose a package",
          "text": "Choose 2lb or 4lb per package. Each size offers 1-pack, 2-pack and 3-pack options.",
          "sourceIds": [
            "catalog",
            "pack-offers"
          ]
        },
        {
          "title": "Before disposal",
          "text": "Check for unabsorbed liquid, close the bag as instructed, and use the sanitary-waste arrangements for your location. Never flush powder or gel.",
          "sourceIds": [
            "guide-thread-pee-powder"
          ]
        }
      ],
      "detailSummary": [
        {
          "title": "For portable sanitation",
          "text": "For liquid-waste containers used during portable toilet, camping or travel situations.",
          "sourceIds": [
            "pee-pdp"
          ]
        },
        {
          "title": "Powder, supplied separately",
          "text": "Available in 2lb and 4lb packages. This is the powder product, not a portable toilet.",
          "sourceIds": [
            "catalog",
            "pee-pdp"
          ]
        }
      ],
      "instructionSummary": {
        "title": "Fit the bag → Add powder → Wait and check → Close",
        "scope": "Absorb collected liquid into a gel. These steps show use in a separate bag fitted to a portable toilet; do not put powder or gel into a flush toilet.",
        "steps": [
          {
            "title": "Fit the collection bag",
            "text": "Fit the bag inside the portable toilet and secure its opening around the seat as directed. Check that the toilet is stable and the bag cannot slip before adding powder.",
            "sourceIds": [
              "guide-thread-pee-powder"
            ]
          },
          {
            "title": "Measure and add before use",
            "text": "Measure the package dose, gently add it to the bottom of the bag, then use the toilet. Use the dose on your package; one cap is not a universal dose.",
            "sourceIds": [
              "guide-thread-pee-powder"
            ]
          },
          {
            "title": "Wait and check after use",
            "text": "Allow liquid to absorb into gel, then look for any unabsorbed liquid. If liquid remains, keep the bag supported and read the full guide’s remaining-liquid advice before lifting it.",
            "sourceIds": [
              "guide-thread-pee-powder"
            ]
          },
          {
            "title": "Close and dispose appropriately",
            "text": "Close the bag using its own closure or instructions. Use the disposal arrangements for your location. Never flush powder or gel down a toilet or drain.",
            "sourceIds": [
              "guide-thread-pee-powder"
            ]
          }
        ]
      }
    },
    "refill": {
      "intro": "A 5LB refill-only format for compatible moisture-absorber containers. Coming soon; not available to order yet.",
      "sourceIds": [
        "refill-page"
      ],
      "guideId": "moisture-refill-sds001",
      "details": [
        {
          "title": "Refill media, not a complete absorber",
          "text": "The contents are calcium chloride pellets for compatible household moisture absorber devices. The 5LB jug supplies refill media; it does not include the absorber tray or collection container.",
          "sourceIds": [
            "refill-page",
            "sds001-pdf"
          ]
        },
        {
          "title": "Let the previous refill finish",
          "text": "Do not top off early. Empty collected liquid when the old crystals have fully dissolved or the liquid reaches the container maximum fill line, then refill the upper tray without overfilling.",
          "sourceIds": [
            "sds001-page"
          ]
        },
        {
          "title": "Protect the jug and the surface",
          "text": "Cap unused crystals tightly and place the absorber upright on a flat, stable surface. Collected liquid is calcium chloride brine and can damage surfaces; wipe spills promptly and rinse the affected area with water.",
          "sourceIds": [
            "sds001-page",
            "sds001-pdf"
          ]
        },
        {
          "title": "The document applies to this product only",
          "text": "SDS001 Revision1.4 identifies ACTICLEAR Moisture Absorber Refill – Calcium Chloride Pellets. It is not the SDS for Muck Clear, Cooking Oil Solidifier or Pee Powder.",
          "sourceIds": [
            "sds001-pdf"
          ]
        }
      ],
      "faqs": [
        {
          "q": "Can I order it now?",
          "a": "Not yet. Moisture Absorber Refill is coming soon and is not currently available to order.",
          "sourceIds": [
            "refill-page"
          ]
        },
        {
          "q": "When should I empty the container?",
          "a": "When the crystals have fully dissolved or collected liquid reaches the maximum fill line. Do not top off the existing crystals early.",
          "sourceIds": [
            "sds001-page"
          ]
        },
        {
          "q": "Where does collected liquid go?",
          "a": "The guide says typical household brine may go into a toilet or sink with plenty of water unless local rules say otherwise. Do not pour it on soil, plants, lawns, metal, fabric, carpet or finished wood.",
          "sourceIds": [
            "sds001-page"
          ]
        },
        {
          "q": "What is the main safety warning?",
          "a": "SDS001 classifies the material as an eye irritant. Avoid eye and skin contact and breathing dust; keep it away from children and pets. Read the full product-specific SDS for handling and first-aid details.",
          "sourceIds": [
            "sds001-pdf",
            "sds001-page"
          ]
        }
      ]
    }
  },
  "guides": [
    {
      "id": "muck-clear-compact",
      "title": "Muck Clear — Small Bottle — Use Instructions & First Aid",
      "productId": "compact",
      "intro": "Treat organic buildup and sludge in ponds, koi ponds, fountains, birdbaths and backyard water gardens. This guide is for the small bottle, dosed by tablet count.",
      "sections": [
        {
          "title": "Before you begin",
          "html": "<p>Have the dose table, a net and a phone or notebook ready. Remove reachable leaves and debris from a stable position. Check water temperature if possible.</p><p><strong>Water temperature:</strong> Best results above 50°F (10°C).</p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "before-use"
        },
        {
          "title": "1. Count the required tablets",
          "html": "<p>Use 1 tablet per 25 US gallons. Find your water volume in the dose table, count the tablets and close the bottle. Spread the dose across the water being treated; do not pile it in one corner.</p>",
          "image": {
            "src": "assets/media/guide-muck-clear-steps-v3.png",
            "alt": "Preparing the label-directed amount of pond treatment tablets.",
            "panel": 0
          },
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "use"
        },
        {
          "title": "2. Spread, do not pile",
          "html": "<p>Distribute the checked dose at several points from safe, stable bank positions rather than in one pile. The picture shows the action, not a tablet-count recommendation.</p>",
          "image": {
            "src": "assets/media/guide-muck-guide-details-v2-novice-water.png",
            "alt": "Distributing tablets at several safe bank positions; depicted counts illustrate the action only.",
            "panel": 1
          },
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "use-step-2"
        },
        {
          "title": "3. Let the tablets sink",
          "html": "<p>Let the tablets sink naturally. Do not premix them in water, bury them or enter the pond to place them; continue normal pond care afterward.</p>",
          "image": {
            "src": "assets/media/guide-muck-clear-steps-v3.png",
            "alt": "Cutaway showing tablets sinking toward the pond bottom.",
            "panel": 2
          },
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "use-step-3"
        },
        {
          "title": "4. Record and plan your check",
          "html": "<p>Record the date and tablet count, and plan a check in 7 days. Before the next dose, use the schedule below to review conditions and count from your last actual application.</p>",
          "image": {
            "src": "assets/media/guide-muck-clear-steps-v3.png",
            "alt": "Recording the application for follow-up pond care.",
            "panel": 3
          },
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "use-step-4"
        },
        {
          "title": "Follow-up: check before you apply",
          "html": "<p><strong>Routine care: every 14 days.</strong> Maintain an improved pond bottom and manage new organic deposits. <strong>Intensive care: every 7 days.</strong> Address existing accumulated organic debris; not every type of bottom sediment calls for intensive treatment.</p><p>Review buildup and water conditions first, then keep or change the plan. <strong>Count from the last actual application</strong>; never stack doses to catch up. This calendar starts at Day 1 and assumes no change of plan.</p><div><table><caption>Example treatment calendar: review buildup before each planned dose</caption><thead><tr><th scope=\"col\">When</th><th scope=\"col\">Routine care</th><th scope=\"col\">Heavy buildup</th></tr></thead><tbody><tr><th scope=\"row\">Day 1</th><td>Prepare, then make the first application</td><td>Prepare, then make the first application</td></tr><tr><th scope=\"row\">Day 8</th><td>Check and record; no routine dose</td><td>Check; apply only if still following this plan and due</td></tr><tr><th scope=\"row\">Day 15</th><td>Check; apply only if still following this plan and due</td><td>Check; apply only if still following this plan and due</td></tr><tr><th scope=\"row\">Day 22</th><td>Check and record; no routine dose</td><td>Check; apply only if still following this plan and due</td></tr><tr><th scope=\"row\">Day 29</th><td>Check that care is still needed; apply only if due</td><td>Choose the next interval first; apply only if due</td></tr></tbody></table></div><p>Day 29 is a review point, not a mandatory dose or completion deadline. For example, after dosing on Day 22, switching to a 14-day interval on Day 29 puts the next possible dose on Day 36, subject to another check.</p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "treatment-plan"
        },
        {
          "title": "Pond care between applications",
          "html": "<p>Use the stated dose and schedule whether or not you have a dedicated aerator. Aeration is recommended for best results.</p><h3>Without an aerator</h3><p>Remove reachable leaves and dead plant debris, and clear away uneaten feed. Keep part of the water surface free of floating plant mats and debris. Do not stir up the pond bottom or add extra product to make up for having no aerator.</p><h3>If you have a fountain or pump</h3><p>Keep existing fountains, waterfalls, circulation and filtration running as their instructions recommend. If you later add or restart an aerator, follow its startup instructions.</p><h3>Review the same spots every 7 days</h3><p>From the bank, compare debris and odor at 2 fixed spots and note how any fish are behaving. If you cannot see the bottom, record that. Check conditions and the time since your last application before dosing again.</p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "aeration"
        },
        {
          "title": "How many tablets do I use?",
          "html": "<div><table><caption>Small-bottle dose per application</caption><thead><tr><th scope=\"col\">Water volume (US gallons)</th><th scope=\"col\">Tablets per application</th></tr></thead><tbody><tr><th scope=\"row\">250</th><td>10 tablets</td></tr><tr><th scope=\"row\">1,000</th><td>40 tablets</td></tr><tr><th scope=\"row\">2,000</th><td>80 tablets</td></tr><tr><th scope=\"row\">4,000</th><td>160 tablets</td></tr></tbody></table></div><p>The dose is <strong>1 tablet per 25 US gallons</strong>. For a rectangular pond, estimate US gallons as length × width × average depth × 7.5, with all measurements in feet. Use the water volume of the area being treated, not the bottle size.</p><p>If your calculated dose is less than one whole tablet or you are unsure how to measure it, <a href=\"#/contact\">contact us for measuring guidance</a>.</p><p><strong>Routine care: every 14 days. Heavy buildup: every 7 days.</strong> These are application intervals; use the table for the amount at each application.</p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "dosage"
        },
        {
          "title": "If something is wrong, what next?",
          "html": "<p>Check the pond’s condition before applying again.</p><h3>Check water temperature</h3><p>Best results when the water is above 50°F (10°C).</p><h3>Recent use of other pond treatments</h3><p>After using an algaecide, disinfectant or fish medication, check both sets of instructions for compatibility and spacing. If unsure, send us the product name and application date. Do not mix different treatments together. Check any UV settings against the relevant product and equipment instructions too.</p><h3>Gasping fish or abnormal water conditions</h3><p>Pause further applications, check the water, aeration and circulation, and promptly contact a pond-care professional. Muck treatment is for organic buildup; it does not replace emergency oxygen support, water-quality assessment or treatment of fish illness.</p><h3>Still unsure after checking?</h3><p>After checking dose, water temperature and incoming debris, send us photos and your application record if you still cannot judge the next step. Do not experiment with repeated extra doses.</p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "troubleshooting"
        },
        {
          "title": "Suitable use, storage and after-use care",
          "html": "<p>Use the dose directions for this package size and the water area being treated.</p><h3>Suitable use</h3><p>For organic buildup and sludge in ponds, koi ponds, fountains, birdbaths and backyard water gardens. Match the tablet count to the water volume using the dose table above.</p><h3>Storage</h3><p>Keep in the original, closed packaging in a cool, dry place. Protect unused product from moisture and follow any additional storage directions on the label.</p><h3>After use</h3><p>Close the package after measuring. Collect accidental spills without raising dust and follow the label and local requirements for disposal of unused product and packaging.</p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "handling"
        },
        {
          "title": "Take care during use",
          "html": "<p>Apply from safe, stable positions on the bank; do not enter the water or wade into sediment to place tablets. Avoid breathing dust or getting the product in your eyes, and wash hands after handling. Keep the original package closed and out of children’s reach.</p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "precautions"
        },
        {
          "title": "First aid",
          "html": "<p>First steps after accidental contact with this product. Keep the product label available.</p><p><strong>In the U.S.:</strong> call Poison Control at <a href=\"tel:+18002221222\">1-800-222-1222</a> for exposure advice. If someone collapses, has a seizure, has trouble breathing or cannot be awakened, <strong>call <a href=\"tel:911\">911</a> immediately</strong>. Do not wait for an email reply.</p><h3>Skin contact</h3><p>Ordinary skin contact generally needs no special treatment. Wash the area clean with water.</p><h3>Eye contact</h3><p>Immediately rinse with plenty of room-temperature water for 15–20 minutes. Remove contact lenses if easy to do. Seek medical attention.</p><h3>If inhaled</h3><p>Move to fresh air. If coughing, irritation or other symptoms persist, seek medical advice. For trouble breathing, call 911 immediately.</p><h3>If swallowed</h3><p>Do not induce vomiting. Contact Poison Control or a medical professional immediately. Do not give anything by mouth to an unconscious person.</p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "first-aid"
        },
        {
          "title": "Need help deciding the next step?",
          "text": "Tell us the pond or treatment-area details, the last application date and amount, and what you have observed. Include photos if available and mention any recent pond treatments.",
          "html": "<p><a href=\"#/contact\">Contact ActiClear</a></p>",
          "sourceIds": [
            "guide-thread-muck-clear",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "guide-contact"
        }
      ],
      "downloads": [],
      "ref": "REF",
      "navTargets": {
        "use": "use",
        "firstAid": "first-aid",
        "care": "handling"
      },
      "updatedAt": "2026-09-08"
    },
    {
      "id": "muck-clear-large",
      "title": "Muck Clear — 5 lb Pail — Use Instructions & First Aid",
      "productId": "large",
      "intro": "Treat organic buildup and sludge in ponds, koi ponds, lakes and along pond shorelines. This is the 5 lb edition: open the premeasured 1 lb bags and apply the tablets.",
      "sections": [
        {
          "title": "This guide is for the 5lb pail",
          "text": "The instructions below cover the 5lb pail with premeasured 1lb bags. For a 15lb package, contact ActiClear with the package details for matching directions.",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "guide-scope"
        },
        {
          "title": "Before you begin",
          "html": "<p>Have the dose table, a net and a phone or notebook ready. Remove reachable leaves and debris from a stable position. Check water temperature if possible.</p><p><strong>Water temperature:</strong> Best results above 50°F (10°C).</p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "before-use"
        },
        {
          "title": "1. Take the required bags",
          "html": "<p>Use 1 bag for 6,000 sq ft; each bag is 1 lb (about 454 g). Confirm the bag count for your area before applying. No weighing is needed. Keep unused bags dry in the closed pail.</p>",
          "image": {
            "src": "assets/media/guide-muck-clear-5lb-steps-v2-bags.png",
            "alt": "Taking a premeasured one-pound bag from the 5 lb pail, with no scale.",
            "panel": 0
          },
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "use"
        },
        {
          "title": "2. Open and spread the tablets",
          "html": "<p>Open each bag and spread its tablets from safe, stable bank positions. Distribute them across the specified area, keep packaging out of the pond, and avoid emptying the whole dose in one spot.</p>",
          "image": {
            "src": "assets/media/guide-muck-clear-5lb-steps-v2-bags.png",
            "alt": "Opening a one-pound bag and distributing the tablets across the target area.",
            "panel": 1
          },
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "use-step-2"
        },
        {
          "title": "3. Let the tablets sink",
          "html": "<p>Let the tablets sink naturally. Do not premix them in water, bury them or enter the pond to place them; continue normal pond care afterward.</p>",
          "image": {
            "src": "assets/media/guide-muck-clear-5lb-steps-v1.png",
            "alt": "Cutaway showing tablets sinking to the pond bottom.",
            "panel": 2
          },
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "use-step-3"
        },
        {
          "title": "4. Record and plan your check",
          "html": "<p>Record the date and bag count, and plan a check in 7 days. Before the next dose, use the schedule below to review conditions and count from your last actual application.</p>",
          "image": {
            "src": "assets/media/guide-muck-guide-details-v1-novice.png",
            "alt": "Recording the application beside a closed pail and sealed packet.",
            "panel": 3
          },
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "use-step-4"
        },
        {
          "title": "Follow-up: check before you apply",
          "html": "<p><strong>Routine care: every 14 days.</strong> Maintain an improved pond bottom and manage new organic deposits. <strong>Intensive care: every 7 days.</strong> Address existing accumulated organic debris; not every type of bottom sediment calls for intensive treatment.</p><p>Review buildup and water conditions first, then keep or change the plan. <strong>Count from the last actual application</strong>; never stack doses to catch up. This calendar starts at Day 1 and assumes no change of plan.</p><div><table><caption>Example treatment calendar: review buildup before each planned dose</caption><thead><tr><th scope=\"col\">When</th><th scope=\"col\">Routine care</th><th scope=\"col\">Heavy buildup</th></tr></thead><tbody><tr><th scope=\"row\">Day 1</th><td>Prepare, then make the first application</td><td>Prepare, then make the first application</td></tr><tr><th scope=\"row\">Day 8</th><td>Check and record; no routine dose</td><td>Check; apply only if still following this plan and due</td></tr><tr><th scope=\"row\">Day 15</th><td>Check; apply only if still following this plan and due</td><td>Check; apply only if still following this plan and due</td></tr><tr><th scope=\"row\">Day 22</th><td>Check and record; no routine dose</td><td>Check; apply only if still following this plan and due</td></tr><tr><th scope=\"row\">Day 29</th><td>Check that care is still needed; apply only if due</td><td>Choose the next interval first; apply only if due</td></tr></tbody></table></div><p>Day 29 is a review point, not a mandatory dose or completion deadline. For example, after dosing on Day 22, switching to a 14-day interval on Day 29 puts the next possible dose on Day 36, subject to another check.</p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "treatment-plan"
        },
        {
          "title": "Pond care between applications",
          "html": "<p>Use the stated dose and schedule whether or not you have a dedicated aerator. Aeration is recommended for best results.</p><h3>Without an aerator</h3><p>Remove reachable leaves and dead plant debris, and clear away uneaten feed. Keep part of the water surface free of floating plant mats and debris. Do not stir up the pond bottom or add extra product to make up for having no aerator.</p><h3>If you have a fountain or pump</h3><p>Keep existing fountains, waterfalls, circulation and filtration running as their instructions recommend. If you later add or restart an aerator, follow its startup instructions.</p><h3>Review the same spots every 7 days</h3><p>From the bank, compare debris and odor at 2 fixed spots and note how any fish are behaving. If you cannot see the bottom, record that. Check conditions and the time since your last application before dosing again.</p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "aeration"
        },
        {
          "title": "How many bags do I use?",
          "html": "<div><table><caption>5 lb edition: dose per application</caption><thead><tr><th scope=\"col\">Treatment area (sq ft)</th><th scope=\"col\">Premeasured bags</th></tr></thead><tbody><tr><th scope=\"row\">6,000</th><td>1 bag = 1 lb</td></tr><tr><th scope=\"row\">30,000</th><td>5 bags = 5 lb</td></tr></tbody></table></div><p>Each bag contains <strong>1 lb (about 454 g)</strong> of tablets. No weighing is needed. For a rectangular area, length × width gives the area: 300 ft × 20 ft = 6,000 sq ft, which uses 1 bag.</p><p>Open the bags and spread the tablets across the area you calculated. Keep the empty bags out of the water. If the area is unclear or the dose does not match whole bags, <a href=\"#/contact\">contact us with your dimensions before applying</a>.</p><p><strong>Routine care: every 14 days. Heavy buildup: every 7 days.</strong> You do not automatically use the whole pail at every application.</p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "dosage"
        },
        {
          "title": "If something is wrong, what next?",
          "html": "<p>Check the pond’s condition before applying again.</p><h3>Check water temperature</h3><p>Best results when the water is above 50°F (10°C).</p><h3>Recent use of other pond treatments</h3><p>After using an algaecide, disinfectant or fish medication, check both sets of instructions for compatibility and spacing. If unsure, send us the product name and application date. Do not mix different treatments together. Check any UV settings against the relevant product and equipment instructions too.</p><h3>Gasping fish or abnormal water conditions</h3><p>Pause further applications, check the water, aeration and circulation, and promptly contact a pond-care professional. Muck treatment is for organic buildup; it does not replace emergency oxygen support, water-quality assessment or treatment of fish illness.</p><h3>Still unsure after checking?</h3><p>After checking dose, water temperature and incoming debris, send us photos and your application record if you still cannot judge the next step. Do not experiment with repeated extra doses.</p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "troubleshooting"
        },
        {
          "title": "Suitable use, storage and after-use care",
          "html": "<p>Use the dose directions for this package size and the water area being treated.</p><h3>Suitable use</h3><p>For organic buildup and sludge in ponds, koi ponds, lakes and along pond shorelines. This 5 lb edition uses area-based dosing. For small fountains or birdbaths, choose the small-bottle product and its <a href=\"#/guides/muck-clear-compact?section=dosage\">volume-based guide</a>.</p><h3>Storage</h3><p>Keep unused bags sealed inside the closed pail in a cool, dry place. Protect them from moisture.</p><h3>After use</h3><p>Collect empty bags and close the pail. Pick up spilled tablets without raising dust, and follow the label and local requirements for unused product and packaging.</p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "handling"
        },
        {
          "title": "Take care during use",
          "html": "<p>Apply from safe, stable positions on the bank; do not enter the water or wade into sediment to place tablets. Avoid breathing dust or getting the product in your eyes, and wash hands after handling. Keep the original package closed and out of children’s reach.</p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "precautions"
        },
        {
          "title": "First aid",
          "html": "<p>First steps after accidental contact with this product. Keep the product label available.</p><p><strong>In the U.S.:</strong> call Poison Control at <a href=\"tel:+18002221222\">1-800-222-1222</a> for exposure advice. If someone collapses, has a seizure, has trouble breathing or cannot be awakened, <strong>call <a href=\"tel:911\">911</a> immediately</strong>. Do not wait for an email reply.</p><h3>Skin contact</h3><p>Ordinary skin contact generally needs no special treatment. Wash the area clean with water.</p><h3>Eye contact</h3><p>Immediately rinse with plenty of room-temperature water for 15–20 minutes. Remove contact lenses if easy to do. Seek medical attention.</p><h3>If inhaled</h3><p>Move to fresh air. If coughing, irritation or other symptoms persist, seek medical advice. For trouble breathing, call 911 immediately.</p><h3>If swallowed</h3><p>Do not induce vomiting. Contact Poison Control or a medical professional immediately. Do not give anything by mouth to an unconscious person.</p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "first-aid"
        },
        {
          "title": "Need help deciding the next step?",
          "text": "Tell us the pond or treatment-area details, the last application date and amount, and what you have observed. Include photos if available and mention any recent pond treatments.",
          "html": "<p><a href=\"#/contact\">Contact ActiClear</a></p>",
          "sourceIds": [
            "guide-thread-muck-clear-5lb",
            "owner-muck-schedule-20260907",
            "owner-muck-care-20260907"
          ],
          "id": "guide-contact"
        }
      ],
      "downloads": [],
      "ref": "REF",
      "navTargets": {
        "use": "use",
        "firstAid": "first-aid",
        "care": "handling"
      },
      "updatedAt": "2026-09-08"
    },
    {
      "id": "cooking-oil-solidifier",
      "title": "Cooking Oil Solidifier — Use Instructions & First Aid",
      "productId": "oil",
      "intro": "Turn used vegetable cooking oil into a solid you can scoop into the trash once fully cooled. Do not reuse treated oil for cooking.",
      "sections": [
        {
          "title": "Before you begin",
          "html": "<p>Have a kitchen thermometer suitable for hot oil, the product scoop, stovetop-safe cookware, a heat-resistant spatula and a trash bin ready. Remove the food. Use 1 scoop per 250 mL of used vegetable oil; see the dose table.</p>",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ],
          "id": "before-use"
        },
        {
          "title": "Add → Stir and cool → Reheat → Remove and dispose",
          "steps": [
            "ADD · Add to hot oil: While the oil is still hot — label temperature: above 170°F/75°C — turn off the heat and sprinkle in 1 scoop per 250 mL of oil.",
            "STIR · Stir, then cool: With the heat off, stir until all flakes have melted. Let the pan cool at room temperature until the oil has solidified. Fully cool but still liquid? Check the guidance below .",
            "REHEAT · Loosen the base: In stovetop-safe cookware, warm briefly over low heat to slightly melt the layer touching the pan. Turn off the heat as soon as the base loosens; do not melt the whole block. Stay with the pan.",
            "REMOVE & DISPOSE · Scoop into the trash: With the heat off, use a heat-resistant spatula to scoop out the loosened solid oil. Place it directly in household trash once fully cooled; never down a drain. Avoid touching the hot pan or oil."
          ],
          "image": {
            "src": "assets/media/guide-cooking-oil-solidifier-steps-v8-beige.png",
            "alt": "Four-step illustration: Add → Stir and cool → Reheat → Remove and dispose.",
            "caption": "Read the four steps from top left to top right, then bottom left to bottom right."
          },
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ],
          "id": "use"
        },
        {
          "title": "How much do I add?",
          "html": "<div><table><caption>Dose per application</caption><thead><tr><th scope=\"col\">Used vegetable oil</th><th scope=\"col\">Product amount</th></tr></thead><tbody><tr><th scope=\"row\">250 mL (1 cup)</th><td>1 scoop — 0.35 oz (about 10 g)</td></tr><tr><th scope=\"row\">500 mL (2 cups)</th><td>2 scoops — 0.70 oz (about 20 g)</td></tr><tr><th scope=\"row\">1 L (4 cups)</th><td>4 scoops — 1.40 oz (about 40 g)</td></tr></tbody></table></div><p>Use the product scoop: <strong>1 scoop is 0.35 oz (about 10 g)</strong>. In this guide, 1 cup means 250 mL of oil. Measure the amount of oil you are treating and use the corresponding product amount.</p>",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ],
          "id": "dose-help"
        },
        {
          "title": "Fully cool but still liquid?",
          "html": "<p>Make sure the product melted completely during stirring and that you used the correct amount for your oil volume. If the problem continues, <a href=\"#/contact\">contact us</a>.</p>",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ],
          "id": "not-solid"
        },
        {
          "title": "Suitable use, storage and after-use care",
          "html": "<p>Use the dose table and steps on this page when treating used vegetable cooking oil.</p><h3>Suitable use</h3><p>For used vegetable cooking oils from household food preparation. Not effective on animal fats. Do not eat the product or reuse treated oil for cooking.</p><h3>Storage</h3><p>Keep unused product in its original, tightly closed packaging in a cool, dry place, away from heat sources.</p><h3>After use</h3><p>Place fully cooled, solidified oil in the household trash, not down the drain. Sort the packaging according to local waste requirements.</p>",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ],
          "id": "handling"
        },
        {
          "title": "Take care around hot oil",
          "html": "<p>Keep children away from the work area. Avoid splashes, breathing powder or getting it in your eyes. Do not add water to hot oil. Never leave heating oil unattended; turn off the heat before adding, stirring or lifting out. Do not eat the product or reuse treated oil for cooking.</p>",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ],
          "id": "precautions"
        },
        {
          "title": "First aid",
          "html": "<p>First steps after accidental contact with this product. Keep the product label available.</p><p><strong>In the U.S.:</strong> call Poison Control at <a href=\"tel:+18002221222\">1-800-222-1222</a> for exposure advice. If someone collapses, has a seizure, has trouble breathing or cannot be awakened, <strong>call <a href=\"tel:911\">911</a> immediately</strong>. Do not wait for an email reply.</p><h3>Product on skin (no burn)</h3><p>Wash the area clean with water and soap.</p><h3>Eye contact</h3><p>Immediately rinse with plenty of room-temperature water for 15–20 minutes. Remove contact lenses if easy to do. Seek medical attention.</p><h3>If inhaled</h3><p>Move to fresh air. If coughing, irritation or other symptoms persist, seek medical advice. For trouble breathing, call 911 immediately.</p><h3>If swallowed</h3><p>Do not induce vomiting. Contact Poison Control or a medical professional immediately. Do not give anything by mouth to an unconscious person.</p><h3>Hot oil or hot-pan burns</h3><p>Cool the burned skin under cool running water for 20 minutes. Do not use ice, oils or creams, or pull away clothing stuck to the burn. Get urgent medical help for a deep or extensive burn, or burns to the face or hands.</p>",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ],
          "id": "first-aid"
        },
        {
          "title": "Need help with the directions?",
          "text": "Tell us how much oil and product you used, whether the product melted completely, and what happened. We will help you with the next step.",
          "html": "<p><a href=\"#/contact\">Contact ActiClear</a></p>",
          "sourceIds": [
            "guide-thread-cooking-oil-solidifier",
            "owner-oil-label-exact-20260907"
          ],
          "id": "guide-contact"
        }
      ],
      "downloads": [],
      "ref": "REF",
      "navTargets": {
        "use": "use",
        "firstAid": "first-aid",
        "care": "handling"
      },
      "updatedAt": "2026-09-08"
    },
    {
      "id": "pee-powder",
      "title": "Pee Powder — Use Instructions & First Aid",
      "productId": "pee",
      "intro": "Absorb collected liquid into a gel. These steps show use in a separate bag fitted to a portable toilet; do not put powder or gel into a flush toilet.",
      "sections": [
        {
          "title": "Before you begin",
          "html": "<p>Have a stable portable toilet, a compatible collection bag, the package-specified measuring item and the bag’s closure ready. Before starting, find the dose and confirm your disposal arrangements. Accessories shown are not necessarily included.</p>",
          "sourceIds": [
            "guide-thread-pee-powder"
          ],
          "id": "before-use"
        },
        {
          "title": "Fit the bag → Add powder → Wait and check → Close",
          "steps": [
            "Fit the collection bag: Fit the bag inside the portable toilet and secure its opening around the seat as directed. Check that the toilet is stable and the bag cannot slip before adding powder.",
            "Measure and add before use: Measure the package dose, gently add it to the bottom of the bag, then use the toilet. The cap illustrates measuring; it does not mean one cap is always the correct dose.",
            "Wait and check after use: Allow liquid to absorb into gel, then look for any unabsorbed liquid. If liquid remains, keep the bag supported and follow “Still have liquid?” before lifting it.",
            "Close and dispose appropriately: Close the bag using its own closure or instructions; the picture shows gathering the opening only. Use the disposal arrangements for your location . Never flush powder or gel down a toilet or drain."
          ],
          "image": {
            "src": "assets/media/guide-pee-powder-steps-v4-novice.png",
            "alt": "Four-step illustration: Fit the bag → Add powder → Wait and check → Close.",
            "caption": "Read the four steps from top left to top right, then bottom left to bottom right."
          },
          "sourceIds": [
            "guide-thread-pee-powder"
          ],
          "id": "use"
        },
        {
          "title": "Before starting: where is the dose?",
          "html": "<p>Find the amount per application, corresponding liquid volume and measuring directions on your package. If any are missing, or you are unsure whether your cap is the measuring item, <a href=\"#/contact\">send us a label photo before use</a>.</p>",
          "sourceIds": [
            "guide-thread-pee-powder"
          ],
          "id": "dose-help"
        },
        {
          "title": "Still have liquid, or unsure it is ready?",
          "html": "<p>Elapsed time or some visible gel does not show that all liquid has been absorbed. Keep the bag supported in the stable toilet, check the powder and liquid amounts, and follow the package’s follow-up directions. If none are provided, <a href=\"#/contact\">contact us</a> rather than inventing a top-up dose or stirring method.</p>",
          "sourceIds": [
            "guide-thread-pee-powder"
          ],
          "id": "remaining-liquid"
        },
        {
          "title": "Handling, storage and cleanup",
          "html": "<p>Keep unused powder separate from the used collection bag.</p><h3>Handling</h3><p>Avoid breathing dust and contact with eyes. Pour carefully and keep the area well ventilated. Wash your hands after handling.</p><h3>Storage</h3><p>Keep unused powder in its tightly closed original packaging in a cool, dry place. Keep it separate from collected waste.</p><h3>After use</h3><p>At a campsite or managed site, use its designated sanitary-waste collection point; ask staff if unsure. At home, ask your local waste service how it accepts bagged toilet waste. Keep the bag closed. Do not flush it or empty it into water or soil.</p>",
          "sourceIds": [
            "guide-thread-pee-powder"
          ],
          "id": "handling"
        },
        {
          "title": "First aid",
          "html": "<p>First steps after accidental contact with this product. Keep the product label available.</p><p><strong>In the U.S.:</strong> call Poison Control at <a href=\"tel:+18002221222\">1-800-222-1222</a> for exposure advice. If someone collapses, has a seizure, has trouble breathing or cannot be awakened, <strong>call <a href=\"tel:911\">911</a> immediately</strong>. Do not wait for an email reply.</p><h3>Skin contact</h3><p>No special treatment is usually needed. Simply rinse the skin clean with water. If a skin reaction occurs or you feel unwell, seek medical advice.</p><h3>Eye contact</h3><p>Immediately rinse cautiously with water for at least 20 minutes. Remove contact lenses if easy to do. Contact an eye specialist.</p><h3>If inhaled</h3><p>Move to fresh air. If coughing, irritation or other symptoms persist, seek medical advice. For trouble breathing, call 911 immediately.</p><h3>If swallowed</h3><p>If fully awake, rinse your mouth and spit out the water. Do not induce vomiting. Contact Poison Control or a medical professional immediately. Do not give anything by mouth to an unconscious person.</p>",
          "sourceIds": [
            "guide-thread-pee-powder"
          ],
          "id": "first-aid"
        },
        {
          "title": "Need a dose or remaining-liquid check?",
          "text": "Send photos of the front and directions on your package, its size, your collection bag, and any known powder and liquid amounts. If you have not used it yet, describe your planned setup.",
          "html": "<p><a href=\"#/contact\">Contact ActiClear</a></p>",
          "sourceIds": [
            "guide-thread-pee-powder"
          ],
          "id": "guide-contact"
        }
      ],
      "downloads": [],
      "ref": "REF",
      "navTargets": {
        "use": "use",
        "firstAid": "first-aid",
        "care": "handling"
      },
      "updatedAt": "2026-09-08"
    },
    {
      "id": "moisture-refill-sds001",
      "title": "Moisture Refill: use, spills and SDS001",
      "productId": "refill",
      "intro": "Product-specific guidance for the coming-soon 5LB ACTICLEAR Moisture Absorber Refill. Calcium chloride refill media is used in a compatible absorber container.",
      "sections": [
        {
          "title": "Refill in the right order",
          "text": "",
          "sourceIds": [
            "sds001-page"
          ],
          "steps": [
            "Wait until the old crystals dissolve or the collected liquid reaches the maximum fill line. Do not top off early.",
            "Empty the collected brine carefully, using the disposal guidance below.",
            "Pour new crystals into the upper tray; follow its fill line and do not overfill.",
            "Close the jug cap immediately and stand the absorber upright on a flat, stable surface.",
            "Wipe spills immediately and rinse the area with water."
          ]
        },
        {
          "title": "Collected liquid",
          "text": "For typical household use, the published guide allows disposal to a toilet or sink with plenty of water unless local rules say otherwise. Rinse the drain area. Do not pour brine on soil, plants, lawns, metal, leather, carpets, fabrics or finished wood.",
          "sourceIds": [
            "sds001-page"
          ]
        },
        {
          "title": "Store and handle",
          "text": "Keep the refill tightly capped in a cool, dry, well-ventilated place, away from moisture and heat. Avoid eye/skin contact and dust. Do not mix with other chemicals. Keep away from children, pets, food and drinks. Wear protective gloves and eye protection when handling bulk material or when dust or splash exposure is possible, as SDS001 specifies.",
          "sourceIds": [
            "sds001-page",
            "sds001-pdf"
          ]
        },
        {
          "title": "First aid — follow the full SDS",
          "text": "SDS001 Revision1.4 specifies eye rinsing for 15–20 minutes, removing contact lenses after the first 5 minutes if easy, and obtaining medical attention if irritation persists. For skin contact, wash with soap and water. If swallowed, rinse the mouth, do not induce vomiting, and contact Poison Control or medical help. In the U.S., the SDS lists Poison Control 1-800-222-1222; call 911 for a life-threatening emergency. See the full SDS for complete measures.",
          "sourceIds": [
            "sds001-pdf"
          ]
        },
        {
          "title": "Document scope",
          "text": "This SDS identifies calcium chloride pellets for ACTICLEAR Moisture Absorber Refill only. It does not cover Muck Clear, Cooking Oil Solidifier or Pee Powder. The simplified guide does not replace the full SDS or the matching product label.",
          "sourceIds": [
            "sds001-pdf"
          ]
        }
      ],
      "downloads": [
        {
          "title": "SDS001 — Calcium Chloride Pellets (PDF)",
          "href": "assets/documents/ACTICLEAR-SDS001-Calcium-Chloride-US-SDS.pdf",
          "sourceId": "sds001-pdf"
        }
      ]
    }
  ],
  "about": {
    "title": "Good ideas travel.",
    "intro": "We’re ActiClear. We find ideas in professional fields and rework them for the everyday things you care about.",
    "kicker": "ABOUT ACTICLEAR",
    "html": "<section id=\"our-approach\" class=\"brand-intro story-origin\"><h2>Dinner’s over. Now, the oil.</h2><p>That last pan of oil has a way of outstaying dinner.</p><p>One of our answers comes from an industrial thickening ingredient. We chose a higher-purity form and developed it for a new job: turning used cooking oil into a solid you can scoop out.</p></section>\n<section class=\"brand-adaptation story-adaptation\"><h2>A little pond. A lot to love.</h2><p>The fish. The quiet. A few minutes for yourself. You shouldn’t need an aquaculture background to care for that.</p><p>Farm professionals choose treatments for particular conditions. We took a formula used in large-scale aquaculture and broadened its mix of microbes with home ornamental ponds in mind.</p><p>Its job: helping break down the organic buildup at the bottom of your pond.</p></section>\n<section class=\"brand-purpose brand-resources story-promise\"><h2>Worth a second look.</h2><p>These are two examples. We keep asking where a good idea could be useful next—and what needs to change.</p><p class=\"story-value\">We consider the materials, too: renewable sources, useful by-products from production, or biological approaches, depending on the product.</p></section>\n<div class=\"callout brand-contact\"><h2>What should we solve next?</h2><p>That little thing you keep putting up with. The task that makes you think, “There must be a better way.”</p><p>Tell us what happens, what you’ve tried, and what you wish were different. Your problem could be the start of our next idea.</p><a class=\"button\" href=\"#/contact\">Share your problem</a></div>"
  },
  "contact": {
    "title": "Talk to ActiClear",
    "email": "info@acticlear.co",
    "intro": "For a product question, include the product name, package size and the issue you need help with.",
    "topics": [
      "Choosing a package or multi-pack",
      "Product directions and packaging",
      "Moisture Refill and SDS001",
      "An order or return question"
    ],
    "sourceIds": [
      "contact-page",
      "sds001-pdf"
    ],
    "formNote": "This offline form creates a local preview; it does not send an email or submit personal details."
  },
  "promotions": [],
  "sources": {
    "compact-pdp": {
      "url": "https://www.acticlear.co/products/muck-clear-natural-pond-sludge-treatment",
      "file": "reference/catalog/muck-clear-natural-pond-sludge-treatment.html",
      "basis": "Public product description and visible FAQs"
    },
    "large-pdp": {
      "url": "https://www.acticlear.co/products/muck-clear-beneficial-bacteria",
      "file": "reference/catalog/muck-clear-beneficial-bacteria.html",
      "basis": "Public product description and visible FAQs; FAQ tablet form preferred to inconsistent powder description"
    },
    "oil-pdp": {
      "url": "https://www.acticlear.co/products/cooking-oil-solidifier",
      "file": "reference/catalog/cooking-oil-solidifier.html",
      "basis": "Public directions and FAQs; rejected inconsistent gallons claim"
    },
    "pee-pdp": {
      "url": "https://www.acticlear.co/products/pee-powder-gel",
      "file": "reference/catalog/pee-powder-gel.html",
      "basis": "Public directions and FAQs; no guaranteed elapsed time in authored copy"
    },
    "refill-page": {
      "url": "https://www.acticlear.co/pages/acticlear-moisture-refill-commercial-v1",
      "file": "reference/catalog/refill-guide.html",
      "basis": "Current Coming soon and 5LB refill-only status"
    },
    "sds001-page": {
      "url": "https://www.acticlear.co/pages/sds001",
      "file": "reference/catalog/sds001.html",
      "basis": "Published refill, storage, brine disposal and safety guide; only Moisture Absorber Refill"
    },
    "sds001-pdf": {
      "url": "https://cdn.shopify.com/s/files/1/0792/6585/7782/files/ACTICLEAR_SDS001_Calcium_Chloride_US_SDS.pdf?v=1786782699",
      "file": "site/assets/documents/ACTICLEAR-SDS001-Calcium-Chloride-US-SDS.pdf",
      "basis": "SDS001 Revision1.4 Aug15 2026; Moisture Absorber Refill calcium chloride pellets only"
    },
    "oil-label": {
      "file": "reference/media/hd-frame-230.jpg",
      "basis": "Actual 22oz rear label in ActiClear-brand source video, independently visually read; media ledger supplies provenance"
    },
    "oil-process": {
      "file": "/Volumes/EHD/Codex/10_独立站/acticlear产品资料/吸油粉/B0DTP6ZLP3/main_005.jpg",
      "basis": "Existing brand image of add/stir/cool/dispose, independently visually inspected; agrees with public PDP"
    },
    "large-packaging": {
      "file": "/Volumes/EHD/Codex/10_独立站/acticlear产品资料/底改5-15LB/B0DJSMDTGT/main_001 (1).jpg",
      "basis": "B independently inspected 15LB actual carton front; use large formats not universal pails"
    },
    "about-page": {
      "url": "https://www.acticlear.co/pages/about-us",
      "file": "reference/catalog/about.html",
      "basis": "Public brand purpose; no unsupported family health outcomes imported"
    },
    "contact-page": {
      "url": "https://www.acticlear.co/pages/contact",
      "file": "reference/catalog/contact.html",
      "basis": "Contact destination; unsupported sweeping safety/environment claims excluded"
    },
    "catalog": {
      "file": "reference/catalog/summary.json",
      "basis": "Fresh public product JSON, ten base variants USD minor-unit prices and availability"
    },
    "pack-offers": {
      "file": "reference/catalog/compact-pack-selector.html",
      "basis": "Current Shopify catalog snapshot covering all 10 package sizes and their 2-pack and 3-pack offers."
    },
    "pee-instruction-image": {
      "type": "existing-own-product-image",
      "path": "/Volumes/EHD/Codex/10_独立站/acticlear产品资料/吸水粉/A+/aplus_004.jpg",
      "sha256": "7a4a37e05e329b7cda922910b21cdf7987a30b4d00434d1cbf412c7d169133ef",
      "reviewNote": "Readable original source inspected; marketing claims in the whole image are not independent efficacy proof. Historical 0.35oz/16.9fl oz urine example retained as source evidence only; latest approved guide leaves current package dose/cap measurement unresolved."
    },
    "pee-dose-image": {
      "type": "existing-own-product-image",
      "path": "/Volumes/EHD/Codex/10_独立站/acticlear产品资料/吸水粉/B0DJSWGBDH/main_004.jpg",
      "sha256": "304c3e10fe0f76e83fdb64cfd92f1a94a757143cc25b3784879f36b600aa3b2d",
      "reviewNote": "Readable original source inspected; marketing claims in the whole image are not independent efficacy proof. Historical numerical example is not a current approved universal dose."
    },
    "pee-label-2lb": {
      "type": "existing-own-product-image",
      "path": "/Volumes/EHD/Codex/10_独立站/acticlear产品资料/吸水粉/B0DJSWGBDH/main_001.jpg",
      "sha256": "161f92542057333b91d46b76c3b81730d466b444fdb6bdb9020ff2647339ae8b",
      "reviewNote": "Readable original source inspected; marketing claims in the whole image are not independent efficacy proof."
    },
    "compact-dose-conflict": {
      "type": "existing-own-product-image",
      "path": "/Volumes/EHD/Codex/10_独立站/acticlear产品资料/底改0.5-4LB/B0DJSQ4S5Z/main_007.jpg",
      "sha256": "bc3b394011684d25af826fefec7791589489c7b05619bd7962f33fb0eea39b5d",
      "reviewNote": "Historical four-week image retained as evidence; public schedule superseded by owner confirmation on 2026-09-07 (routine 14 days / heavy 7 days)."
    },
    "guide-thread-muck-clear": {
      "file": "/Volumes/EHD/Codex/10_独立站/acticlear-homepage/content-review-v1/product-guides/muck-clear/index.html",
      "basis": "Latest referenced-task approved English guide, canonical oil-beige-20260907, 2026-09-07. Product-specific first-aid text retained; no new SDS.",
      "doseLabel": "/Volumes/EHD/Codex/10_独立站/acticlear-homepage/content-review-v1/product-guides-internal/muck-label-update-20260907/muck-small-label.png"
    },
    "guide-thread-muck-clear-5lb": {
      "file": "/Volumes/EHD/Codex/10_独立站/acticlear-homepage/content-review-v1/product-guides/muck-clear-5lb/index.html",
      "basis": "Latest referenced-task approved English guide, canonical oil-beige-20260907, 2026-09-07. Product-specific first-aid text retained; no new SDS.",
      "doseLabel": "/Volumes/EHD/Codex/10_独立站/acticlear-homepage/content-review-v1/product-guides-internal/muck-label-update-20260907/muck-5lb-label.png"
    },
    "guide-thread-cooking-oil-solidifier": {
      "file": "/Volumes/EHD/Codex/10_独立站/acticlear-homepage/content-review-v1/product-guides/cooking-oil-solidifier/index.html",
      "basis": "Latest referenced-task approved English guide, canonical oil-beige-20260907, 2026-09-07. Product-specific first-aid text retained; no new SDS."
    },
    "guide-thread-pee-powder": {
      "file": "/Volumes/EHD/Codex/10_独立站/acticlear-homepage/content-review-v1/product-guides/pee-powder/index.html",
      "basis": "Latest referenced-task approved English guide, canonical oil-beige-20260907, 2026-09-07. Product-specific first-aid text retained; no new SDS."
    },
    "owner-muck-schedule-20260907": {
      "file": "Referenced task 01a07059-fd80-7610-b0cd-875a53188f80, user message at 2026-09-07T07:09:51.672Z (source transcript line 12235)",
      "basis": "Owner explicitly sets both Muck guides to every 2 weeks routine / every 1 week for heavy buildup, superseding printed 4/2-week directions."
    },
    "owner-muck-care-20260907": {
      "file": "Referenced task user messages 2026-09-07T09:18:53.472Z and 2026-09-07T09:43:41.037Z (lines 14053 and 14412)",
      "basis": "Owner confirms label-dose tables, Fahrenheit-first best-results wording, aeration as recommendation, broader own-listing scenarios and ordinary skin washing."
    },
    "owner-oil-label-exact-20260907": {
      "file": "/Volumes/EHD/Codex/10_独立站/acticlear-homepage/content-review-v1/product-guides-internal/oil-label-update-20260907/oil-11oz-label.png",
      "basis": "Owner-supplied label visually read during merge. Latest user messages lines 14458/14465/14556 require literal 170°F/75°C and ADD/STIR/REHEAT/REMOVE & DISPOSE; line 14674 selects beige background."
    }
  },
  "homeFaqs": [
    {
      "q": "How do Muck Clear tablets reach the bottom?",
      "a": "Add the sinking tablets directly to the pond or water feature so they sink toward settled muck and sludge. Use the dose and repeat schedule on your matching package.",
      "productId": "compact",
      "sourceIds": [
        "compact-pdp",
        "compact-dose-conflict"
      ]
    },
    {
      "q": "When should I add Cooking Oil Solidifier?",
      "a": "Turn off the heat while the used oil is still at least 170°F, then add the powder and stir until dissolved. Let it cool and solidify before removal. Follow the measuring directions for your selected package.",
      "productId": "oil",
      "sourceIds": [
        "oil-pdp",
        "oil-label"
      ]
    },
    {
      "q": "Can I flush gelled waste from Pee Powder?",
      "a": "No. Wait until the waste is visibly gelled, then use the permitted local solid-waste route. Do not flush the gel.",
      "productId": "pee",
      "sourceIds": [
        "pee-pdp"
      ]
    },
    {
      "q": "Does Moisture Refill include an absorber?",
      "a": "No. The 5LB package supplies refill media for compatible moisture-absorber containers; the absorber tray and collection container are not included. This format is Coming Soon.",
      "productId": "refill",
      "sourceIds": [
        "refill-page",
        "sds001-page"
      ]
    }
  ]
};
